import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { AidRequestForm } from "../aid-request-form";
import { OpportunityCategory } from "../opportunity-category";
import { Organization } from "../organization";
import { SubCategory } from "../sub-category";
import { UserCategoryPreference } from "../user-category-preference";
import { CategoryEntityConfig } from "./config";
import { CategoryFilters } from "./filters";
import { CategoryMethods } from "./methods";

@HyperEntity("category", CategoryEntityConfig)
export class Category extends extender(CategoryFilters, CategoryMethods) {
  @Fields.id()
  id = "";

  @Fields.string()
  name = "";

  @Relations.toMany(() => SubCategory, "category")
  subCategories: SubCategory[] = [];

  @Relations.toMany(() => OpportunityCategory, "categoryId")
  opportunities: OpportunityCategory[] = [];

  @Relations.toMany(() => UserCategoryPreference, "categoryId")
  userCategoryPreferences: UserCategoryPreference[] = [];

  @Fields.string({ dbName: "organization_id" })
  organizationId = "";

  @Relations.toOne<Category, Organization>(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.boolean({ dbName: "is_sensitive" })
  isSensitive = false;

  @Fields.boolean({ dbName: "is_hidden" })
  isHidden = false;

  @Fields.boolean({ dbName: "is_hidden_from_preferences" })
  isHiddenFromPreferences = false;

  @Fields.integer({ dbName: "sort_order" })
  sortOrder = 10000;

  @Fields.string({ dbName: "aid_request_form_id" })
  aidRequestFormId = "";

  @Relations.toOne<Category, AidRequestForm>(
    () => AidRequestForm,
    "aidRequestFormId",
  )
  aidRequestForm?: AidRequestForm;

  @Fields.literal(() => ["AID_REQUEST", "FILTER"], { allowNull: true })
  type: "AID_REQUEST" | "FILTER" | null = null;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
